import { useUserRoles } from '@anytag/auth';
import { EngagementDetail } from '@anytag/graphql';
import { Form, UploadButton } from '@anytag/shared-atoms';
import { useToggleState } from '@anytag/shared-hooks';
import { UploadCsvModal } from '@anytag/shared-molecules';
import { FilterAction } from '@anytag/shared-types';
import { getRestApiUrl } from '@anytag/shared-utils';
import {
  PostReportFilter,
  DownloadPostReportsButton,
  PostReportFilterFormValues,
  DownloadPostReportsButtonProps
} from '../../../PostReport';
import { useUploadEngagementReportFile } from './useUploadEngagementReportFile';

export interface EngagementReportFilterProps
  extends FilterAction<PostReportFilterFormValues>,
    Pick<DownloadPostReportsButtonProps, 'segmentState' | 'defaultColumnsForDownload'> {
  engagement: EngagementDetail;
}
export const EngagementReportFilter = ({
  filter,
  setFilter,
  segmentState,
  defaultColumnsForDownload,
  engagement: { id, title, startDate, endDate }
}: EngagementReportFilterProps) => {
  const uploadModal = useToggleState();
  const { isAdminStaff } = useUserRoles();
  const { uploading, handleUploadFile } = useUploadEngagementReportFile({ campaignId: id });

  return (
    <PostReportFilter
      filter={{ ...filter, startDate: filter.startDate || startDate, endDate: filter.endDate || endDate }}
      setFilter={setFilter}
    >
      {isAdminStaff ? (
        <>
          <Form.Field className="flex-none">
            <UploadButton onClick={uploadModal.open} loading={uploading} />
          </Form.Field>

          <UploadCsvModal
            uploading={uploading}
            open={uploadModal.status}
            onClose={uploadModal.close}
            onCustomUpload={handleUploadFile}
            downloadTranslationKey="User can manual upload template and also upload it"
            downloadFile={{
              extension: '.csv',
              filenamePrefix: `manual-upload-template (${title})`,
              url: getRestApiUrl(`report/campaign/engagement/${id}/upload_report/csv/`)
            }}
          />
        </>
      ) : null}

      <Form.Field className="flex-none">
        <DownloadPostReportsButton
          filter={filter}
          campaignId={id}
          segmentState={segmentState}
          defaultColumnsForDownload={defaultColumnsForDownload}
        />
      </Form.Field>
    </PostReportFilter>
  );
};
